$(document).on('load turbolinks:load', () => I18n.locale = $('body').data('locale')); // eslint-disable-line no-return-assign, no-undef
